import React, { createContext } from 'react';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import usePatientInfoForm from './usePatientInfoForm';

export const PatientInfoFormContext = createContext();

export const PatientInfoFormProvider = ({
    children,
    onSubmitSuccess,
    sendMetric,
}) => {
    const patientInfoForm = usePatientInfoForm({
        onSubmitSuccess,
        sendMetric,
    });

    return (
        <PatientInfoFormContext.Provider value={patientInfoForm}>
            {children}
        </PatientInfoFormContext.Provider>
    );
};

export default withCustomMetrics({
    category: 'Booking - Patient Info',
    page: 'Booking',
    section: 'Patient Info View',
})(PatientInfoFormProvider);
